import type { DiscussionComment } from '@peruselab/api-client/discussions';

/** The comment with `id` anywhere in the thread, for "Continue this thread" (ADR 0016 D4). */
export function findComment(comments: readonly DiscussionComment[], id: string): DiscussionComment | null {
  for (const comment of comments) {
    if (comment.id === id) return comment;
    const found = findComment(comment.replies, id);
    if (found) return found;
  }
  return null;
}

/** How many replies sit under a comment, at any depth -- shown on a collapsed comment. */
export function countReplies(comment: DiscussionComment): number {
  return comment.replies.reduce((total, reply) => total + 1 + countReplies(reply), 0);
}

/** Every comment in the thread, at any depth. */
export function countComments(comments: readonly DiscussionComment[]): number {
  return comments.reduce((total, comment) => total + 1 + countReplies(comment), 0);
}

const URL_PATTERN = /\bhttps?:\/\/[^\s<>"']+[^\s<>"'.,;:!?)\]]/g;

/** Plain text split into text and link pieces (ADR 0016 phase 1 is plain text + links; Markdown is D7). */
export function linkify(text: string): readonly ({ readonly text: string } | { readonly href: string })[] {
  const pieces: ({ text: string } | { href: string })[] = [];
  let last = 0;
  for (const match of text.matchAll(URL_PATTERN)) {
    if (match.index > last) pieces.push({ text: text.slice(last, match.index) });
    pieces.push({ href: match[0] });
    last = match.index + match[0].length;
  }
  if (last < text.length) pieces.push({ text: text.slice(last) });
  return pieces;
}
